
import { Player, CourtResult, TournamentState } from '@/types/tournament';

// Extended interfaces for Americano support
export interface AmericanoPlayer {
  id: string;
  name: string;
  points: number;
  gamesPlayed: number;
  partnerships: string[];
  roundScores?: number[];
  isOnBench?: boolean;
  joinedAt?: Date;
}

export interface AmericanoMatch {
  court: number;
  team1: { player1: AmericanoPlayer; player2: AmericanoPlayer };
  team2: { player1: AmericanoPlayer; player2: AmericanoPlayer };
  score?: { team1: number; team2: number };
}

// Updated storage structures to include player information
interface MexicanoRoundData {
  courts: Player[][];
  results: (CourtResult & {
    players: {
      team1: { player1: string; player2: string };
      team2: { player1: string; player2: string };
    };
  })[];
}

interface AmericanoRoundData {
  matches: AmericanoMatch[];
  results: (AmericanoMatch & {
    players: {
      team1: { player1: string; player2: string };
      team2: { player1: string; player2: string };
    };
  })[];
}

export interface ExtendedTournamentState extends TournamentState {
  stateVersion?: number;
  tournamentType: 'mexicano' | 'americano' | 'team_americano' | null;
  americanoPlayers: AmericanoPlayer[];
  americanoMatches: AmericanoMatch[];
  americanoRoundResults: AmericanoMatch[][]; // Store completed matches for each round
  isRoundActive: boolean;
  isFinished: boolean;
  // UPDATED: Store court assignments and results with player info for each round
  roundCourts: MexicanoRoundData[]; // [round] - stores court assignments and results per round
  roundAmericanoMatches: AmericanoRoundData[]; // Store match assignments and results per round
  teamAmericanoFixedTeams?: Array<{ player1: AmericanoPlayer; player2: AmericanoPlayer }>; // Fixed teams for team_americano
}

export interface TournamentContextType {
  tournamentState: ExtendedTournamentState;
  startTournament: (players: Player[], rounds: number, type?: 'mexicano' | 'americano' | 'team_americano') => void;
  submitRoundResults: (results: CourtResult[]) => void;
  resetTournament: (silent?: boolean) => Promise<void>;
  showLeaderboard: boolean;
  setShowLeaderboard: (value: boolean) => void;
  // Americano specific methods
  finishAmericanoRound: (results: any[]) => void;
  finishTournament: () => void;
  setTournamentType: (type: 'mexicano' | 'americano' | 'team_americano' | null) => void;
  goToPreviousRound: () => void;
  refresh: () => Promise<void>;
}

export const defaultTournamentState: ExtendedTournamentState = {
  players: [],
  courts: [],
  results: [],
  currentRound: 0,
  totalRounds: 0,
  isActive: false,
  tournamentType: null,
  americanoPlayers: [],
  americanoMatches: [],
  americanoRoundResults: [],
  isRoundActive: false,
  isFinished: false,
  roundCourts: [], // Initialize empty array for round court storage
  roundAmericanoMatches: [], // Initialize empty array for round match storage
  teamAmericanoFixedTeams: undefined,
};
